import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gallery-block__wrap" }
const _hoisted_2 = { class: "image-card lazy-image__wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "image-card__caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, {
      ref: "gallery",
      wrap: "",
      class: "gallery-block"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, idx) => {
          return _withDirectives((_openBlock(), _createBlock(_component_v_col, {
            key: idx,
            tag: "a",
            sm: _ctx.checkIndex(idx),
            cols: "12",
            href: image.url,
            class: "pa-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  class: "lazy-image",
                  src: image.url,
                  alt: ""
                }, null, 8, _hoisted_3),
                _createElementVNode("div", _hoisted_4, _toDisplayString(image.caption), 1)
              ])
            ]),
            _: 2
          }, 1032, ["sm", "href"])), [
            [_vShow, idx < 6]
          ])
        }), 128))
      ]),
      _: 1
    }, 512),
    (_ctx.images.length > 5)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          class: "show-all-button",
          color: "white",
          size: "small",
          onClick: _withModifiers(_ctx.openGallery, ["prevent","stop"])
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Show all photos ")
          ])),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}